export class Summary {
  constructor(
    readonly callId: string,
    readonly content: string,
    readonly finishedAt: string,
    private readonly status:
      | 'pending'
      | 'not-verified'
      | 'failed'
      | 'approved'
      | 'rejected'
      | 'modified'
      | 'created'
      | 'started',
  ) {}

  get isCreated(): boolean {
    return this.status === 'created';
  }

  get isPending(): boolean {
    return this.status === 'pending' || this.status === 'started';
  }

  get isFailed(): boolean {
    return this.status === 'failed';
  }

  get isModified(): boolean {
    return this.status === 'modified';
  }

  get isApproved(): boolean {
    return this.status === 'approved';
  }

  get isNotVerified(): boolean {
    return this.status === 'not-verified';
  }

  get isRejected(): boolean {
    return this.status === 'rejected';
  }

  get isReady(): boolean {
    return this.isNotVerified || this.isApproved || this.isRejected || this.isModified;
  }

  get canBeVerified(): boolean {
    return this.isNotVerified || this.isApproved || this.isRejected;
  }

  get canBeModified(): boolean {
    return this.isProcessingFinished;
  }

  private get isProcessingFinished(): boolean {
    return this.isReady || this.isFailed;
  }
}
